<template>
  <b-row class="mx-1">
    <b-col cols="10">
      <b>Přidat Soubory:</b>
      <b-form-file
        id="filesUpload"
        class="uploadForm"
        :style="`background-image: url('${photosBackground}');`"
        v-model="files"
        :state="Boolean(files)"
        multiple
        placeholder
        drop-placeholder
      />
    </b-col>

    <b-col cols="2">
      <b-row>
        <b-button @click="uploadFiles" variant="success" class="mt-4 btn-block mx-4">Nahrát soubory</b-button>
      </b-row>
      <b-row>
        <b-button variant="success" @click="$router.go(-1)" class="mt-4 btn-block mx-4">Zpět</b-button>
      </b-row>
      <b-row>
        <b-button variant="danger" @click="cancelSelection  " class="mt-4 btn-block mx-4">Zrušit</b-button>
      </b-row>
    </b-col>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="uploadWait"
      title="Nahrávám soubory"
    >
      <div class="text-center">
        <b-spinner variant="success" label="Spinning"></b-spinner>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'filesUpload',
  data: () => ({
    photosBackground: require('../assets/files-upload.svg'),
    files: []
  }),
  mounted () {

  },
  components: {

  },
  methods: {
    cancelSelection () {
      this.files = []
    },
    uploadFiles: function () {
      this.$bvModal.show('uploadWait')
      let requests = this.files.reduce((promiseChain, item) => {
        return promiseChain.then(() => new Promise((resolve) => {
          const formData = new FormData()
          formData.append('upload', item)
          axios
            .post(`/api/v1/people/${this.$route.params.id}/attachment`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(response => {
              console.log('Upload souboru dokoncen')
              resolve()
            })
            .catch(response => {
              this.$bvModal.hide('uploadWait')
              alert('upload error: ', response)
            })
        }))
      }, Promise.resolve())

      requests.then(() => {
        axios
          .get(`/api/v1/people/${this.$route.params.id}/attachment`)
          .then(response => {
            this.files = []
            let formatedData = []
            let peopleID = this.$route.params.id
            response.data.forEach(function (data) {
              formatedData.push({
                date: new Date((data.time)).toLocaleDateString(),
                filename: data.filename,
                size: `${Math.round(data.size / 1024)} kB`,
                file: `<a href="api/v1/people/${peopleID}/attachment/${data.filename}"> 
            <img width="30px" height="30px" src="/api/v1/icon/${data.icon}"/> </a>`,
                delLink: ``

              })
            })
            this.$store.commit('attachedFiles', formatedData)
            this.$bvModal.hide('uploadWait')
          })
          .catch(response => {
            console.log('loadFiles Error: ' + response)
          })
      })
    }
  }
})
</script>

<style>
.uploadForm {
  height: 200px;
  width: 100%;
  border: 1px solid rgba(133, 116, 116, 0.4);
  border-radius: 5px;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  border-style: solid;
}
</style>
